import { graphql, PageProps } from 'gatsby';
import React from 'react';

import SeoHead from '../components/head';
import { ContentfulPageContent } from '../templates/page/contentfulPage/content';

export default function Homepage(props: PageProps<Queries.HomepagePageContentQuery>) {
  return (
    <ContentfulPageContent {...props} />
  )
}
export const Head = (props: PageProps<Queries.HomepagePageContentQuery>) => {
  const { pageData } = props.data

  return <SeoHead {...pageData} pathname={props.location.pathname} />
}

export const query = graphql`
  query HomepagePageContent {
    pageData: contentfulHomepage {
      id 
      title
      description
      # image {
      #   id
      #   url
      #   publicURL
      # }
      contentful_id
      __typename
      blocks: content {
        blockType: __typename
        ...HomepageHeroContent
        ...HomepageFeatureListContent
        ...HomepageCtaContent
        ...HomepageProductListContent
        ...RichTextBlockContent
      }
      # structuredSchemaData {
      #   id
      #   itemType: __typename
      #   questionText
      #     answerText
      # }
    }
  }
`
